import { render, staticRenderFns } from "./TutorialCard.vue?vue&type=template&id=2596934c&scoped=true&"
import script from "./TutorialCard.vue?vue&type=script&lang=js&"
export * from "./TutorialCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorialCard.vue?vue&type=style&index=0&id=2596934c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596934c",
  null
  
)

export default component.exports